import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, Nav, NavItem, NavLink, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import classnames from "classnames";
import GeneralTab from '../Tabs/GeneralTab';
import ParticipantsTab from '../Tabs/ParticipantsTab';
import ResiduesCollectedTab from '../Tabs/ResiduesCollectedTab';
import PhotographicRecordsTab from '../Tabs/PhotographicRecordsTab';
import { useSelector, useDispatch } from 'react-redux';
import { getBeachCleaningData, registerBeachCleaning, uploadFile } from '../../../slices/thunks';
import { createSelector } from 'reselect';
import useFileType from '../../../Components/Hooks/useFileTypeHooks';
import dayjs from 'dayjs';
import ResumeTab from '../Tabs/ResumeTab';
import { useLoading } from '../../../Context/LoadingContext';
import usePathFolder from '../../../Components/Hooks/usePathFolder';
import useUploadFiles from '../../../Components/Hooks/useUploadFiles';
import { generateBeachCleaningReportPDF } from '../Reports/BeachCleaningReport';
import useLogoLoader from '../../../Components/Hooks/useLogoLoaderHooks';
import { cleanDataBeachCleaning } from '../../../slices/beachCleaning/reducer';

const BeachCleaningForm = (props) => {

    const selectorBeachCleaning = createSelector(
        state => state.BeachCleanings,
        guide => ({
            registerDisabled: guide.registerDisabled,
            dataBeachCleaning: guide.dataBeachCleaning,
            isAdding: guide.isAdding,
            isAdded: guide.isAdded,
            isUpdating: guide.isUpdating,
            isUpdated: guide.isUpdated,
            isLoadingList: guide.isLoadingList,
            itemBeachCleaning: guide.itemBeachCleaning,
            error: guide.error,
        })
    );
    const {
        registerDisabled,
        dataBeachCleaning,
        isAdding,
        isAdded,
        isUpdating,
        isUpdated,
        isLoadingList,
        itemBeachCleaning,
        error,
        // requireCloseModal,
    } = useSelector(selectorBeachCleaning);
    const dispatch = useDispatch();
    
    const { logoSrc } = useLogoLoader('login');
    const navigate = useNavigate();
    const { idBeachCleaning } = useParams();
    const { openLoading, closeLoading } = useLoading();
    const [participantsList, setParticipantsList] = useState([]);
    const [residuesCollectedList, setResiduesCollectedList] = useState([]);
    const [photographicRecordsList, setPhotographicRecordsList] = useState([]);

    const [selectedSector, setSelectedSector] = useState(null);
	const handleSectorSelected = (optionSelected) => {
		setSelectedSector(optionSelected);
	};

    const [selectedBeachCleaningReason, setSelectedBeachCleaningReason] = useState(null);
	const handleBeachCleaningReasonSelected = (optionSelected) => {
		setSelectedBeachCleaningReason(optionSelected);
	};

    const { file_type } = useFileType('RES');

    const validation = useFormik({
        // enableReinitialize: use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            id: null,
            date: null,
            establishment_id: '',
            sector_id: '',
            beach_cleaning_reason_id: '',
            kilometers_traveled: '',
            is_done: '',
            observation: ''
        },
        validationSchema: Yup.object({
            date: Yup.date().nullable().required('Campo requerido'),
            sector_id: Yup.string().required('Campo requerido'),
            beach_cleaning_reason_id: Yup.string().when('is_done', {
                is: value => typeof value === 'boolean',
                then: schema => schema.required('Campo requerido'),
                otherwise: schema => schema.notRequired(),
            }),
            is_done: Yup.mixed()
                .oneOf([true, false], 'Campo requerido')
                .required('Campo requerido'),
            kilometers_traveled: Yup.number()
                .typeError('Campo requerido')
                .required('Campo requerido')
        }),
        onSubmit: async (values) => {
            openLoading();
            const selectedEstablishment = selectedSector?.establishment || dataBeachCleaning?.sector?.establishment;
            const establishmentId = selectedEstablishment?._id || values.establishment_id;
            const establishmentLatitude = selectedEstablishment?.latitude || '';
            const establishmentLongitude = selectedEstablishment?.longitude || '';

            // Upload all photographic records
            const promiseUpdatedPhotographicRecords = await photographicRecordsList.map(async (item) => {
                if(!item.id && !item.document_id){
                    try {
                        const dataUploadedFiles = await uploadFiles(
                            pathFolder,
                            {
                                establishment_id: establishmentId
                            },
                            [{
                                file_type_id: file_type?._id,
                                file: item.document
                            }]
                        );
                        return {
                            ...item,
                            latitude: establishmentLatitude,
                            longitude: establishmentLongitude,
                            'document_id': dataUploadedFiles?.files[0]
                        };
                    } catch (err){
                        console.error('Error al subir archivo:', err);
                        return {
                            ...item,
                            latitude: establishmentLatitude,
                            longitude: establishmentLongitude
                        }
                    }
                }else{
                    return {
                        ...item,
                        latitude: establishmentLatitude,
                        longitude: establishmentLongitude
                    }
                }
            });
            const updatedPhotographicRecords = await Promise.all(promiseUpdatedPhotographicRecords);

            try {
                try{
                    const reportPDF = await generateBeachCleaningReportPDF(
                        dispatch,
                        logoSrc,
                        {
                            ...validation.values,
                            guides: dataBeachCleaning?.guides || [],
                            beach_cleaning_type_id: "66feef314218b6636be09e09",
                            participants: participantsList,
                            residues_collected: residuesCollectedList,
                            photographic_records: updatedPhotographicRecords
                        },
                        updatedPhotographicRecords
                    )
                    
                    const dataUploadedFiles = await uploadFiles(
                        pathFolder,
                        {
                            establishment_id: establishmentId
                        },
                        [{
                            file_type_id: file_type?._id,
                            file: reportPDF
                        }]
                    );

                    
                    const updateDataBeachCleaning = {
                        ...validation.values,
                        beach_cleaning_type_id: "66feef314218b6636be09e09",
                        participants: participantsList,
                        residues_collected: residuesCollectedList,
                        photographic_records: updatedPhotographicRecords,
                        ...(reportPDF && {
                            'document_id': dataUploadedFiles?.files[0]
                        })
                    }
                    const responseRegisterCleaning = await dispatch(registerBeachCleaning(updateDataBeachCleaning)).unwrap();
                
                }catch(error){
                    console.error('Error al generar y guardar pdf:', error);
                }
                toast.info('Será redireccionado al listado de limpiezas de playa registradas.', { autoClose: 3000 });
                setTimeout(() => {
                    closeLoading();
                    navigate('/residue/beach-cleanings');
                }, 3500);
                
            } catch (error){
                // setIsLoading(false);
                closeLoading();
                console.error('Error al subir archivo:', error);
            }
        }
    });

    const {
        isEdit = false,
        handleToggleModal,
        handleChangeTitleForm = null,
        isOpen,
        // activeTab,
        // toggleTab,
        idResidueType = null,
        allowEstablishmentSelection = true,
        requireGuideDetailRegisterList = false,
        originEstablishmentId = null,
        nameOperation = null,
        dataThunk = null,
        thunk = null,
        establishmentListSelect = null,
        reducerState = null,
        reducerReset = null,
    } = props;

    const pathFolder = usePathFolder(
        (
            selectedSector?.establishment?.code_siep +
            ' - ' +
            selectedSector?.establishment?.name
        ) || '',
        'Limpiezas',
        selectedSector?.name || '',
        (
            validation.values.date
                ? dayjs(validation.values.date).format('DD-MM-YYYY')
                : ''
        )
    );

    const {
        uploadFiles
    } = useUploadFiles();

    const [activeTab, setactiveTab] = useState(1);
    const [activeArrowTab, setactiveArrowTab] = useState(4);
    const [activeVerticalTab, setactiveVerticalTab] = useState(7);
    const [progressbarvalue, setprogressbarvalue] = useState(0);
    const [passedSteps, setPassedSteps] = useState([1]);
    const [passedarrowSteps, setPassedarrowSteps] = useState([1]);
    const [passedverticalSteps, setPassedverticalSteps] = useState([1]);

    function toggleTab(tab, value) {
        if (activeTab !== tab) {
            var modifiedSteps = [...passedSteps, tab];

            if (tab >= 1 && tab <= 4) {
                setactiveTab(tab);
                setPassedSteps(modifiedSteps);
            }
        }
        setprogressbarvalue(value);
    }

    function toggleArrowTab(tab) {
        if (activeArrowTab !== tab) {
            var modifiedSteps = [...passedarrowSteps, tab];

            if (tab >= 4 && tab <= 7) {
                setactiveArrowTab(tab);
                setPassedarrowSteps(modifiedSteps);
            }
        }
    }

    async function toggleVerticalTab(tab) {
        if (tab > 7) {
            const requiredGeneralFields = ['date', 'sector_id'];
            const validationErrors = await validation.validateForm();

            requiredGeneralFields.forEach((fieldName) => {
                validation.setFieldTouched(fieldName, true, false);
            });

            const hasGeneralTabErrors = requiredGeneralFields.some((fieldName) => Boolean(validationErrors[fieldName]));
            if (hasGeneralTabErrors) {
                toast.error('Complete los campos obligatorios de Datos Generales antes de continuar.', { autoClose: 3000 });
                return;
            }
        }

        if (activeVerticalTab !== tab) {
            var modifiedSteps = [...passedverticalSteps, tab];

            if (tab >= 7 && tab <= 11) {
                setactiveVerticalTab(tab);
                setPassedverticalSteps(modifiedSteps);
            }
        }
    }

    useEffect(() => {
        if (idBeachCleaning) {
            dispatch(getBeachCleaningData(idBeachCleaning))
        }

        return () => {
            dispatch(cleanDataBeachCleaning())
        }
    }, [])

    useEffect(() => {
        if (!idBeachCleaning) {
        }
    }, [idBeachCleaning]);

    useEffect(() => {
        if(dataBeachCleaning){
            validation.setFieldValue('id', dataBeachCleaning.id)
            validation.setFieldValue('date', dataBeachCleaning.date ? new Date(dataBeachCleaning.date) : '')
            validation.setFieldValue('sector_id', dataBeachCleaning.sector_id || dataBeachCleaning.sector?._id || '')
            validation.setFieldValue('establishment_id', dataBeachCleaning.establishment_id || dataBeachCleaning.sector?.establishment?._id || '')
            validation.setFieldValue('beach_cleaning_reason_id', dataBeachCleaning.beach_cleaning_reason_id || dataBeachCleaning.beach_cleaning_reason?._id || '')
            validation.setFieldValue('kilometers_traveled', dataBeachCleaning.kilometers_traveled || '')
            validation.setFieldValue('is_done', typeof dataBeachCleaning.is_done === 'boolean' ? dataBeachCleaning.is_done : '')
            validation.setFieldValue('observation', dataBeachCleaning.observation || '')
            setParticipantsList(Array.isArray(dataBeachCleaning['participants']) ? dataBeachCleaning['participants'] : [])
            setResiduesCollectedList(Array.isArray(dataBeachCleaning['residues_collected']) ? dataBeachCleaning['residues_collected'] : [])
            setPhotographicRecordsList(Array.isArray(dataBeachCleaning['photographic_records']) ? dataBeachCleaning['photographic_records'] : [])
            setSelectedSector(dataBeachCleaning?.sector || null)
            setSelectedBeachCleaningReason(dataBeachCleaning?.beach_cleaning_reason || null)
        }
    }, [dataBeachCleaning])

    useEffect(() => {
        if(selectedSector){
            // El API devuelve 'id' (no '_id'), pero también soportamos _id por compatibilidad
            validation.setFieldValue('sector_id', selectedSector?.id || selectedSector?._id || selectedSector?.value || '')
            // Actualizar establishment_id si el sector trae el objeto establishment
            const estId = selectedSector?.establishment?.id || selectedSector?.establishment?._id
            if (estId) {
                validation.setFieldValue('establishment_id', estId)
            }
        }
    }, [selectedSector])

    return (
        <React.Fragment>
            <Row>
            <Col xl={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">Registrar Limpieza de Playa</h4>
                </CardHeader>
                <CardBody>
                    <form
                        className="vertical-navs-step form-steps"
                        onSubmit={(event) => {
                            event.preventDefault();
                            return false;
                        }}
                    >
                        <Row className="gy-5">
                            <Col lg={3}>
                                <Nav
                                    className="flex-column custom-nav nav-pills"
                                >
                                    <NavItem>
                                        <NavLink
                                        href="#"
                                        className={
                                            (classnames({
                                            active: activeVerticalTab === 7,
                                            done: (activeVerticalTab <= 11 && activeVerticalTab > 7)
                                            }))
                                        }
                                        onClick={(event) => {
                                            event.preventDefault();
                                            toggleVerticalTab(7);
                                        }}
                                        >
                                        <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2"></i>
                                            {/* Paso 1 */}
                                        </span>
                                        Datos Generales
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                        href="#"
                                        className={
                                            (classnames({
                                            active: activeVerticalTab === 8,
                                            done: (activeVerticalTab <= 11 && activeVerticalTab >= 8)
                                            }))
                                        }
                                        onClick={(event) => {
                                            event.preventDefault();
                                            toggleVerticalTab(8);
                                        }}
                                        >
                                        <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2"></i>
                                            {/* Paso 2 */}
                                        </span>
                                        Participantes
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                        href="#"
                                        className={classnames({
                                            active: activeVerticalTab === 9,
                                            done: (activeVerticalTab <= 11 && activeVerticalTab >= 9)
                                        })}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            toggleVerticalTab(9);
                                        }}
                                        >
                                        <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2"></i>
                                            {/* Paso 3 */}
                                        </span>
                                        Residuos Recolectados
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                        href="#"
                                        className={classnames({
                                            active: activeVerticalTab === 10,
                                            done: (activeVerticalTab <= 11 && activeVerticalTab >= 10)
                                        })}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            toggleVerticalTab(10);
                                        }}
                                        >
                                        <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2"></i>
                                            {/* Paso 4 */}
                                        </span>
                                        Registros Fotográficos
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                        href="#"
                                        className={classnames({
                                            active: activeVerticalTab === 11,
                                            done: (activeVerticalTab <= 11 && activeVerticalTab >= 11)
                                        })}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            toggleVerticalTab(11);
                                        }}
                                        >
                                        <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2"></i>
                                            {/* Paso 4 */}
                                        </span>
                                        Resumen de Limpieza de Playa
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                            <Col lg={9}>
                                <div className="px-lg-4">
                                    <TabContent activeTab={activeVerticalTab}>
                                        <TabPane tabId={7}>
                                            <GeneralTab
                                                dataBeachCleaning={dataBeachCleaning}
                                                validation={validation}
                                                handleSector={handleSectorSelected}
                                                handleReason={handleBeachCleaningReasonSelected}
                                            />
                                        </TabPane>
                                        <TabPane tabId={8}>
                                            <ParticipantsTab
                                                participantsList={participantsList}
                                                handleParticipantsList={setParticipantsList}
                                            />                              
                                        </TabPane>
                                        <TabPane tabId={9}>
                                            <ResiduesCollectedTab
                                                residuesCollectedList={residuesCollectedList}
                                                handleResiduesCollectedList={setResiduesCollectedList}
                                            />
                                        </TabPane>
                                        <TabPane tabId={10}>
                                            <PhotographicRecordsTab
                                                photographicRecordsList={photographicRecordsList}
                                                handlePhotographicRecordsList={setPhotographicRecordsList}
                                                selectedSector={selectedSector}
                                                dataBeachCleaning={dataBeachCleaning}
                                            />
                                        </TabPane>
                                        <TabPane tabId={11}>
                                            <ResumeTab
                                                validation={validation}
                                                info={{
                                                    ...validation.values,
                                                    sector: selectedSector,
                                                    beach_cleaning_reason: selectedBeachCleaningReason,
                                                }}
                                                participants={participantsList}
                                                residuesCollected={residuesCollectedList}
                                                photographicRecords={photographicRecordsList}
                                            />
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </Col>
                        </Row>
                    </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </React.Fragment>
    );
};

export default BeachCleaningForm;
